import { useEffect, useState } from 'react'
import { motion } from 'framer-motion'
import { Button } from '../common/Button'
import { FiCheck } from 'react-icons/fi'
import { settingsService, PublicSettings } from '../../services/settingsService'

const planFeatures = [
  'Projetos ilimitados',
  'Tarefas e subtarefas ilimitadas',
  'Dashboard completo',
  'Visualização Kanban',
  'OKRs e objetivos',
  'Gerenciamento de equipes',
  'Comentários e colaboração',
  'Documentos centralizados',
  'Sprints e metodologia ágil',
  'Time tracking',
  'Sem limite de usuários colaboradores',
  'Dark mode',
  'Suporte fácil e rápido',
  'Atualizações constantes',
]

export const Pricing = ({ onSignup }: { onSignup: () => void }) => {
  const [settings, setSettings] = useState<PublicSettings | null>(null)

  useEffect(() => {
    settingsService.getPublicSettings().then(setSettings)
  }, [])

  const formatPrice = (value: number) => {
    return value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  }

  return (
    <section id="pricing" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="container mx-auto max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Preços Simples e Transparentes
          </h2>
          <p className="text-xl text-gray-600">
            Um único plano com todas as funcionalidades. Sem surpresas.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="bg-gradient-to-br from-primary-600 to-primary-700 rounded-2xl shadow-2xl p-8 sm:p-12 text-white"
        >
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold mb-2">Plano Pro</h3>
            <div className="mb-4">
              <div className="text-5xl font-bold mb-1">
                {settings ? `R$ ${formatPrice(settings.price_per_seat)}` : 'R$ --,--'}
              </div>
              <div className="text-sm text-primary-100">por mês/usuário administrador</div>
            </div>
            <p className="text-primary-100">
              Tudo que você precisa para gerenciar projetos com eficiência
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-8">
            <ul className="space-y-3">
              {planFeatures.map((feature, index) => (
                <motion.li
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.3, delay: index * 0.05 }}
                  className="flex items-center gap-3"
                >
                  <FiCheck className="flex-shrink-0" size={20} />
                  <span>{feature}</span>
                </motion.li>
              ))}
            </ul>
          </div>

          <div className="text-center">
            <Button
              onClick={onSignup}
              variant="secondary"
              size="lg"
              className="w-full sm:w-auto bg-white text-primary-600 hover:bg-gray-100"
            >
              Assinar Agora
            </Button>
            <p className="text-sm text-primary-100 mt-4">
              {settings ? `Teste por ${settings.trial_days} dias` : 'Período de teste grátis'} • Cancele quando quiser
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  )
}

